import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess404051ParamStatus: 'idle',
    startProcess404051ParamError: undefined as any,
    loadUserParamsProcess404051ParamStatus: 'idle',
    loadUserParamsProcess404051ParamError: undefined as any,

    process404051ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess404051Param = createAsyncThunk('process404051ParamSlice/startProcess404051Param', async ({ process404051Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess404051Param/`,
        prepareData(process404051Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess404051ParamStatus } = getState().process404051ParamSlice
        return startProcess404051ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess404051Param = createAsyncThunk('process404051ParamSlice/loadUserParamsProcess404051Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess404051Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess404051ParamStatus } = getState().process404051ParamSlice
        return loadUserParamsProcess404051ParamStatus !== 'pending'
    }
})

const Process404051ParamSlice = createSlice({
    name: 'process404051ParamSlice',
    initialState,
    reducers: {
        resetstartProcess404051Param: (state) => {
            state.job = undefined
            state.startProcess404051ParamError = undefined
        },
        resetstartProcess404051ParamError: (state) => {
            state.startProcess404051ParamError = undefined
        },
        resetloadUserParamsProcess404051Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess404051ParamError = undefined
        },
        resetloadUserParamsProcess404051ParamError: (state) => {
            state.loadUserParamsProcess404051ParamError = undefined
        },
        removeFromProcess404051ParamListById: (state, action) => {
            state.process404051ParamList = state.process404051ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess404051ParamListByIds: (state, action) => {
            state.process404051ParamList = state.process404051ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process404051ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess404051ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process404051ParamList = []
            state.startProcess404051ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess404051Param.pending, (state) => {
            state.startProcess404051ParamStatus = 'pending'
            state.startProcess404051ParamError = undefined
        })
        builder.addCase(startProcess404051Param.fulfilled, (state, action) => {
            state.startProcess404051ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess404051Param.rejected, (state, action) => {
            state.startProcess404051ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess404051ParamError = action.error.message
            } else {
                state.startProcess404051ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess404051Param.pending, (state) => {
            state.loadUserParamsProcess404051ParamStatus = 'pending'
            state.loadUserParamsProcess404051ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess404051Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess404051ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess404051Param.rejected, (state, action) => {
            state.loadUserParamsProcess404051ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess404051ParamError = action.error.message
            } else {
                state.loadUserParamsProcess404051ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess404051Param,
    resetstartProcess404051ParamError,
    resetloadUserParamsProcess404051Param,
    resetloadUserParamsProcess404051ParamError,
    removeFromProcess404051ParamListById,
    removeFromProcess404051ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process404051ParamSlice.actions
export default Process404051ParamSlice.reducer
